import { render, staticRenderFns } from "./SupervisorsList.vue?vue&type=template&id=7df59338&"
import script from "./SupervisorsList.vue?vue&type=script&lang=js&"
export * from "./SupervisorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports